module.exports = __webpack_public_path__ + "static/img/fullscreen-image_hr-drive-included_600.b89634d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_hr-drive-included_600.png
// module id = th3t
// module chunks = 0